import { render, staticRenderFns } from "./StaticTermsAndConditions.vue?vue&type=template&id=4f046788&scoped=true&"
import script from "./StaticTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./StaticTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./StaticTermsAndConditions.vue?vue&type=style&index=0&id=4f046788&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f046788",
  null
  
)

export default component.exports